export enum Event {
  PAGEVIEW = 'pageview',
  INTERACTION = 'interaction'
}

export enum Section {
  ATTENDEE = 'Webinar:Attendee'
}

export enum Subsection {
  LIVE = 'Live',
  PRE_LIVE = 'PreLive'
}

export enum LiveSource {
  Club = 'Club',
  OnlineEvent = 'EventoOnline',
  Sparkle = 'Sparkle',
  Webinar = 'Webinar'
}

export enum EventCategory {
  TermConditions = 'Webinar:Attendee:TermConditions',
  Participate = 'Webinar:Attendee:Participate'
}

export enum EventAction {
  ClickTermAccept = 'Click:TermAccept',
  ClickWantToParticipate = 'Click:WantToParticipate'
}

export enum EventLabel {
  Accept = 'Accept',
  WantToParticipate = 'WantToParticipate'
}

export interface InteractionParams {
  category: EventCategory,
  action: EventAction,
  label?: EventLabel
}

export interface PageviewParams {
  userId?: number | string,
  subsection: string,
  subsection2?: string,
  logged: boolean,
  liveSource?: LiveSource
}
